import { Component } from '@angular/core';
import { MarketE } from '../models/market';
import { AuthenticateService } from '../services/authenticate.service';
import { CurrentUserI, UserDefaultRolesE } from '../models/user';
import { RestrictedAccessPopupService } from '../services/restricted-access-popup.service';
import { stringIsUuid } from '../shared/utils/stringUtils';

@Component({
    selector: 'app-main',
    templateUrl: 'main.component.html'
})
export class MainComponent {
    minutesBeforeShowExpiredBanner = 60 * 24 * 1; // 1 days
    hideTrialExpiredBanner = false;

    constructor(
        private authenticateService: AuthenticateService,
        private restrictedAccessPopupService: RestrictedAccessPopupService
    ) {}

    get userMarket(): 'be' | 'lu' {
        return this.authenticateService.currentUser?.markets.includes(MarketE.BE) ? 'be' : 'lu';
    }

    get currentUser(): CurrentUserI {
        return this.authenticateService.currentUser;
    }

    get companyNameForSubjectOfMail(): string {
        return stringIsUuid(this.currentUser.companyName) ? '' : `(${this.currentUser.companyName})`;
    }

    get isTrialCompanyManager(): boolean {
        return this.currentUser && this.currentUser.roles.includes(UserDefaultRolesE.TRIAL_COMPANY_MANAGER);
    }

    get canViewYearlyReviewOfActiveLegalProfessionals(): boolean {
        return (
            this.currentUser &&
            this.currentUser.roles.includes(UserDefaultRolesE.COMPANY_MANAGER) &&
            this.currentUser.shouldReviewDeclaredUsers &&
            this.currentUser?.markets.includes(MarketE.BE)
        );
    }

    get canViewTrialExpiredBanner(): boolean {
        return (
            !this.hideTrialExpiredBanner &&
            this.currentUser &&
            this.currentUser.companyOnTrial &&
            this.currentUser.companyMinutesBeforeExpirationDate &&
            this.currentUser.companyMinutesBeforeExpirationDate < this.minutesBeforeShowExpiredBanner
        );
    }

    upgradePlan(): void {
        this.restrictedAccessPopupService.show({ askToUpgrade: true });
    }
}
